module.exports = "img/flags/SC.efb836f.png";